import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  initCalendar,
  setCalendarView,
  setCalendarEvents,
} from "../../actions/calendarActions";
import moment from "moment";
import Toolbar from "./Toolbar";
import MonthView from "./MonthView";
import WeekView from "./WeekView";
import DayView from "./DayView";
import axios from "../../axios-instance";
import { getAdminBusinessId } from "../../utils/authHelper";
import {
  mapCalendarDefaultView,
  mapCalendarFirstDayToMoment,
} from "../../utils/eventConfigHelpers";

const Calendar = (props) => {
  const {
    views = ["month", "week", "day"],
    events = [],
    shortEventSlot = false,
    showMoreInPopup = false,
    onSelectEvent = () => {},
    onNavigate = () => {},
    onSelectSlot = () => {},
  } = props;

  const [calendarEvents, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [timeFormat, setTimeFormat] = useState("12");
  const [calendarFirstDay, setCalendarFirstDay] = useState(0);
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const businessId = getAdminBusinessId();
    if (!businessId) {
      props.initCalendar({
        views,
        shortEventSlot,
        showMoreInPopup,
        onSelectEvent,
        onNavigate,
        onSelectSlot,
      });
      setConfigLoaded(true);
      return;
    }

    axios
      .get(`/admin/settings/event/${businessId}`)
      .then((res) => {
        const resData = res?.data || {};
        const config = resData?.data?.data || resData?.data || {};
        const firstDay = mapCalendarFirstDayToMoment(config.calendar_first_day);
        const defaultView = config.calendar_default_view
          ? mapCalendarDefaultView(config.calendar_default_view)
          : "month";

        setCalendarFirstDay(firstDay);
        setTimeFormat(config.time_format ? String(config.time_format) : "12");
        props.setCalendarView(defaultView);
        props.initCalendar({
          views,
          shortEventSlot,
          showMoreInPopup,
          onSelectEvent,
          onNavigate,
          onSelectSlot,
        });
        setConfigLoaded(true);
      })
      .catch(() => {
        props.initCalendar({
          views,
          shortEventSlot,
          showMoreInPopup,
          onSelectEvent,
          onNavigate,
          onSelectSlot,
        });
        setConfigLoaded(true);
      });

    return () => {
      moment.updateLocale("en", {
        week: {
          dow: 0,
        },
      });
    };
  }, []);

  useEffect(() => {
    if (!configLoaded) {
      return;
    }

    moment.updateLocale("en", {
      week: {
        dow: calendarFirstDay,
      },
    });
  }, [calendarFirstDay, configLoaded]);

  useEffect(() => {
    setEvents(events);
  }, [events]);

  if (!configLoaded) {
    return null;
  }

  return (
    <div className="rd_vacationfilterpart rd_calendartabthing2 mx-0">
      <div className="box_content">
        <div className="custom_calendar">
          <Toolbar
            currentDate={currentDate}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            calendarFirstDay={calendarFirstDay}
          />
          {props.calendar.selectedView === "month" && (
            <MonthView
              events={calendarEvents}
              currentDate={currentDate}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              timeFormat={timeFormat}
              calendarFirstDay={calendarFirstDay}
            />
          )}
          {props.calendar.selectedView === "week" && (
            <WeekView
              events={calendarEvents}
              currentDate={currentDate}
              selectedDate={selectedDate}
              timeFormat={timeFormat}
              calendarFirstDay={calendarFirstDay}
            />
          )}
          {props.calendar.selectedView === "day" && (
            <DayView
              events={calendarEvents}
              currentDate={currentDate}
              selectedDate={selectedDate}
              timeFormat={timeFormat}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendar: state.calendar,
});

export default connect(mapStateToProps, {
  initCalendar,
  setCalendarView,
  setCalendarEvents,
})(Calendar);
